// import { lazy } from "react";

// // Authentication related pages
import Landing from "../pages/Auth/index";
import Login from "../pages/Auth/login";
import Register from "../pages/Auth/register";
// const Login = lazy(() => import("../pages/Auth/index"));
// // const Landing = lazy(() => import("../pages/Landing/index"));
// const Register = lazy(() => import("../pages/Auth/register"));

//Dashboard
import Dashboard from "../pages/Dashboard/index";
import MyAccount from "../pages/My-Account/index";
import NotFound from "../pages/NotFoundPage/index";
import Questions from "../pages/FAQ/index";
import Terms from "../pages/TermsConditions/index";
import ContactUs from "../pages/ContactUs/index";
import AboutProgram from "../pages/AboutProgram/index";
// const Dashboard = lazy(() => import("../pages/Dashboard/index"));
// const MyAccount = lazy(() => import("../pages/My-Account/index"));
// const NotFound = lazy(() => import("../pages/NotFoundPage/index"));

const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/my-account", exact: true, component: MyAccount },
  { path: "/not-found", component: NotFound },
  { path: "/faq", component: Questions },
  { path: "/terms-conditions", component: Terms },
  { path: "/contact-us", component: ContactUs },
  { path: "/about-program", component: AboutProgram },
];

const publicRoutes = [
  { path: "/", exact: true, component: Landing },
  { path: "/:id", exact: true, component: Landing },
  // { path: "/", exact: true, component: Landing },
  { path: "/create-account", exact: true, component: Register },
  {
    path: "/create-account/:id",
    exact: true,
    component: Register,
  },
  { path: "/login", exact: true, component: Login },
  { path: "/login/:id", exact: true, component: Login },
  { path: "/faq", component: Questions },
  { path: "/terms_Condition", component: Terms },
  { path: "/contact_us", component: ContactUs },
  { path: "/about_program", component: AboutProgram },
];

export { authProtectedRoutes, publicRoutes };
